<template>
  <div>
    <!--    -&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;
    <div class="el-card" style="display: flex; justify-content: center;align-items: center;
    margin-bottom: 10px;width: 300px;height: 310px;border: 1px solid gainsboro;" @click="deviceInformation()">
      <div class="kt"><el-button id="kt-button"></el-button></div>
      <span style="font-size: 14px;position: absolute;top: 160px">{{ equ_name }}</span>
      <div class="buttonC">
        <el-button class="a"><span id="all">改前耗电:<span style="color: blue">{{ ktThreeA }}</span>kWh</span></el-button>
        <el-button class="b"><span id="all">改后耗电:<span style="color: blue">{{ ktThreeB }}</span>kWh</span></el-button>
        <el-button class="c"><span id="all">累计节省电能:<span style="color: blue">{{ ktThreeC }}</span>kWh</span></el-button>
        <el-button class="d"><span id="all">实时节电率:<span style="color: red">{{ ktThreeD }}</span>%</span></el-button>
        <el-button class="e"><span id="all">近一天最高节电率:<span style="color: red">{{ ktThreeE}}</span>%</span></el-button>
        <el-button class="f"><span id="all">近一天平均节电率:<span style="color: red">{{ ktThreeF }}</span>%</span></el-button>
      </div>
    </div>

    <div class="el-card" style="display: flex; justify-content: center;align-items: center;
    margin-bottom: 10px;width: 300px;height: 310px;border: 1px solid gainsboro;margin-left: 310px" @click="dialogFormVisible = true">
      <div class="acu"><el-button id="acu-button"></el-button></div>
      <span style="font-size: 14px;position: absolute;top: 160px">2#风机</span>
      <div class="buttonC" style="text-align: left">
        <el-button class="a"><span id="all">改前耗电:<span style="color: blue">{{ ktThreeA }}</span>kWh</span></el-button>
        <el-button class="b"><span id="all">改后耗电:<span style="color: blue">{{ ktThreeB }}</span>kWh</span></el-button>
        <el-button class="c"><span id="all">累计节省电能:<span style="color: blue">{{ ktThreeC }}</span>kWh</span></el-button>
        <el-button class="d"><span id="all">实时节电率:<span style="color: red">{{ ktThreeD }}</span>%</span></el-button>
        <el-button class="e"><span id="all">近一天最高节电率:<span style="color: red">{{ ktThreeE }}</span>%</span></el-button>
        <el-button class="f"><span id="all">近一天平均节电率:<span style="color: red">{{ ktThreeF }}</span>%</span></el-button>
      </div>
    </div>

    <div class="el-card" style="display: flex; justify-content: center;align-items: center;
    margin-bottom: 10px;width: 300px;height: 310px;border: 1px solid gainsboro;margin-left: 620px" @click="dialogFormVisible = true">
      <div class="ktt"><el-button id="kt-button"></el-button></div>
      <span style="font-size: 14px;position: absolute;top: 160px">3#风机</span>
      <div class="buttonC" style="text-align: left">
        <el-button class="a"><span id="all">改前耗电:<span style="color: blue">{{ ktThreeA }}</span>kWh</span></el-button>
        <el-button class="b"><span id="all">改后耗电:<span style="color: blue">{{ ktThreeB }}</span>kWh</span></el-button>
        <el-button class="c"><span id="all">累计节省电能:<span style="color: blue">{{ ktThreeC }}</span>kWh</span></el-button>
        <el-button class="d"><span id="all">实时节电率:<span style="color: red">{{ ktThreeD }}</span>%</span></el-button>
        <el-button class="e"><span id="all">近一天最高节电率:<span style="color: red">{{ ktThreeE }}</span>%</span></el-button>
        <el-button class="f"><span id="all">近一天平均节电率:<span style="color: red">{{ ktThreeF }}</span>%</span></el-button>
      </div>
    </div>

    <div class="el-card" style="display: flex; justify-content: center;align-items: center;
    margin-bottom: 10px;width: 300px;height: 310px;border: 1px solid gainsboro;margin-left: 930px" @click="dialogFormVisible = true">
      <div class="acu"><el-button id="acu-button"></el-button></div>
      <span style="font-size: 14px;position: absolute;top: 160px">4#风机</span>
      <div class="buttonC" style="text-align: left">
        <el-button class="a"><span id="all">改前耗电:<span style="color: blue">{{ ktThreeA }}</span>kWh</span></el-button>
        <el-button class="b"><span id="all">改后耗电:<span style="color: blue">{{ ktThreeB }}</span>kWh</span></el-button>
        <el-button class="c"><span id="all">累计节省电能:<span style="color: blue">{{ ktThreeC }}</span>kWh</span></el-button>
        <el-button class="d"><span id="all">实时节电率:<span style="color: red">{{ ktThreeD }}</span>%</span></el-button>
        <el-button class="e"><span id="all">近一天最高节电率:<span style="color: red">{{ ktThreeE }}</span>%</span></el-button>
        <el-button class="f"><span id="all">近一天平均节电率:<span style="color: red">{{ ktThreeF }}</span>%</span></el-button>
      </div>
    </div>

    <div class="el-card" style="display: flex; justify-content: center;align-items: center;
    margin-bottom: 10px;width: 300px;height: 310px;border: 1px solid gainsboro;position: absolute;top: 380px" @click="dialogFormVisible = true">
      <div class="kt"><el-button id="kt-button"></el-button></div>
      <span style="font-size: 14px;position: absolute;top: 160px">1#水泵</span>
      <div class="buttonC" style="text-align: left">
        <el-button class="a"><span id="all">改前耗电:<span style="color: blue">{{ ktThreeA }}</span>kWh</span></el-button>
        <el-button class="b"><span id="all">改后耗电:<span style="color: blue">{{ ktThreeB }}</span>kWh</span></el-button>
        <el-button class="c"><span id="all">累计节省电能:<span style="color: blue">{{ ktThreeC }}</span>kWh</span></el-button>
        <el-button class="d"><span id="all">实时节电率:<span style="color: red">{{ ktThreeD }}</span>%</span></el-button>
        <el-button class="e"><span id="all">近一天最高节电率:<span style="color: red">{{ ktThreeE }}</span>%</span></el-button>
        <el-button class="f"><span id="all">近一天平均节电率:<span style="color: red">{{ ktThreeF }}</span>%</span></el-button>
      </div>
    </div>

    <div class="el-card" style="display: flex; justify-content: center;align-items: center;
    margin-bottom: 10px;width: 300px;height: 310px;border: 1px solid gainsboro;margin-left: 310px;position: absolute;top: 380px" @click="dialogFormVisible = true">
      <div class="acu"><el-button id="acu-button"></el-button></div>
      <span style="font-size: 14px;position: absolute;top: 160px">2#水泵</span>
      <div class="buttonC" style="text-align: left">
        <el-button class="a"><span id="all">改前耗电:<span style="color: blue">{{ ktThreeA }}</span>kWh</span></el-button>
        <el-button class="b"><span id="all">改后耗电:<span style="color: blue">{{ ktThreeB }}</span>kWh</span></el-button>
        <el-button class="c"><span id="all">累计节省电能:<span style="color: blue">{{ ktThreeC }}</span>kWh</span></el-button>
        <el-button class="d"><span id="all">实时节电率:<span style="color: red">{{ ktThreeD }}</span>%</span></el-button>
        <el-button class="e"><span id="all">近一天最高节电率:<span style="color: red">{{ ktThreeE }}</span>%</span></el-button>
        <el-button class="f"><span id="all">近一天平均节电率:<span style="color: red">{{ ktThreeF }}</span>%</span></el-button>
      </div>
    </div>

    <div class="el-card" style="display: flex; justify-content: center;align-items: center;
    margin-bottom: 10px;width: 300px;height: 310px;border: 1px solid gainsboro;margin-left: 620px;position: absolute;top: 380px" @click="dialogFormVisible = true">
      <div class="ktt"><el-button id="kt-button"></el-button></div>
      <span style="font-size: 14px;position: absolute;top: 160px">3#水泵</span>
      <div class="buttonC" style="text-align: left">
        <el-button class="a"><span id="all">改前耗电:<span style="color: blue">{{ ktThreeA }}</span>kWh</span></el-button>
        <el-button class="b"><span id="all">改后耗电:<span style="color: blue">{{ ktThreeB }}</span>kWh</span></el-button>
        <el-button class="c"><span id="all">累计节省电能:<span style="color: blue">{{ ktThreeC }}</span>kWh</span></el-button>
        <el-button class="d"><span id="all">实时节电率:<span style="color: red">{{ ktThreeD }}</span>%</span></el-button>
        <el-button class="e"><span id="all">近一天最高节电率:<span style="color: red">{{ ktThreeE }}</span>%</span></el-button>
        <el-button class="f"><span id="all">近一天平均节电率:<span style="color: red">{{ ktThreeF }}</span>%</span></el-button>
      </div>
    </div>

    <div class="el-card" style="display: flex; justify-content: center;align-items: center;
    margin-bottom: 10px;width: 300px;height: 310px;border: 1px solid gainsboro;margin-left: 930px;position: absolute;top: 380px" @click="dialogFormVisible = true">
      <div class="acu"><el-button id="acu-button"></el-button></div>
      <span style="font-size: 14px;position: absolute;top: 160px">4#水泵</span>
      <div class="buttonC" style="text-align: left">
        <el-button class="a"><span id="all">改前耗电:<span style="color: blue">{{ ktThreeA }}</span>kWh</span></el-button>
        <el-button class="b"><span id="all">改后耗电:<span style="color: blue">{{ ktThreeB }}</span>kWh</span></el-button>
        <el-button class="c"><span id="all">累计节省电能:<span style="color: blue">{{ ktThreeC }}</span>kWh</span></el-button>
        <el-button class="d"><span id="all">实时节电率:<span style="color: red">{{ ktThreeD }}</span>%</span></el-button>
        <el-button class="e"><span id="all">近一天最高节电率:<span style="color: red">{{ ktThreeE }}</span>%</span></el-button>
        <el-button class="f"><span id="all">近一天平均节电率:<span style="color: red">{{ ktThreeF }}</span>%</span></el-button>
      </div>
    </div>

    <div class="el-card" style="display: flex; justify-content: center;align-items: center;
    margin-bottom: 10px;width: 300px;height: 310px;border: 1px solid gainsboro;position: absolute;top: 700px" @click="dialogFormVisible = true">
      <div class="kt"><el-button id="kt-button"></el-button></div>
      <span style="font-size: 14px;position: absolute;top: 160px">大生纺织9号防爆空调</span>
      <div class="buttonC" style="text-align: left">
        <el-button class="a"><span id="all">改前耗电:<span style="color: blue">{{ ktThreeA }}</span>kWh</span></el-button>
        <el-button class="b"><span id="all">改后耗电:<span style="color: blue">{{ ktThreeB }}</span>kWh</span></el-button>
        <el-button class="c"><span id="all">累计节省电能:<span style="color: blue">{{ ktThreeC }}</span>kWh</span></el-button>
        <el-button class="d"><span id="all">实时节电率:<span style="color: red">{{ ktThreeD }}</span>%</span></el-button>
        <el-button class="e"><span id="all">近一天最高节电率:<span style="color: red">{{ ktThreeE }}</span>%</span></el-button>
        <el-button class="f"><span id="all">近一天平均节电率:<span style="color: red">{{ ktThreeF }}</span>%</span></el-button>
      </div>
    </div>

    <div class="el-card" style="display: flex; justify-content: center;align-items: center;
    margin-bottom: 10px;width: 300px;height: 310px;border: 1px solid gainsboro;margin-left: 310px;position: absolute;top: 700px" @click="dialogFormVisible = true">
      <div class="acuu"><el-button id="acu-button"></el-button></div>
      <span style="font-size: 14px;position: absolute;top: 160px">大生纺织10号冷风机</span>
      <div class="buttonC" style="text-align: left">
        <el-button class="a"><span id="all">改前耗电:<span style="color: blue">{{ ktThreeA }}</span>kWh</span></el-button>
        <el-button class="b"><span id="all">改后耗电:<span style="color: blue">{{ ktThreeB }}</span>kWh</span></el-button>
        <el-button class="c"><span id="all">累计节省电能:<span style="color: blue">{{ ktThreeC }}</span>kWh</span></el-button>
        <el-button class="d"><span id="all">实时节电率:<span style="color: red">{{ ktThreeD }}</span>%</span></el-button>
        <el-button class="e"><span id="all">近一天最高节电率:<span style="color: red">{{ ktThreeE }}</span>%</span></el-button>
        <el-button class="f"><span id="all">近一天平均节电率:<span style="color: red">{{ ktThreeF }}</span>%</span></el-button>
      </div>
    </div>

    <div class="el-card" style="display: flex; justify-content: center;align-items: center;
    margin-bottom: 10px;width: 300px;height: 310px;border: 1px solid gainsboro;margin-left: 620px;position: absolute;top: 700px" @click="dialogFormVisible = true">
      <div class="ktt"><el-button id="kt-button"></el-button></div>
      <span style="font-size: 14px;position: absolute;top: 160px">大生纺织11号空调</span>
      <div class="buttonC" style="text-align: left">
        <el-button class="a"><span id="all">改前耗电:<span style="color: blue">{{ ktThreeA }}</span>kWh</span></el-button>
        <el-button class="b"><span id="all">改后耗电:<span style="color: blue">{{ ktThreeB }}</span>kWh</span></el-button>
        <el-button class="c"><span id="all">累计节省电能:<span style="color: blue">{{ ktThreeC }}</span>kWh</span></el-button>
        <el-button class="d"><span id="all">实时节电率:<span style="color: red">{{ ktThreeD }}</span>%</span></el-button>
        <el-button class="e"><span id="all">近一天最高节电率:<span style="color: red">{{ ktThreeE }}</span>%</span></el-button>
        <el-button class="f"><span id="all">近一天平均节电率:<span style="color: red">{{ ktThreeF }}</span>%</span></el-button>
      </div>
    </div>

    <div class="el-card" style="display: flex; justify-content: center;align-items: center;
    margin-bottom: 10px;width: 300px;height: 310px;border: 1px solid gainsboro;margin-left: 930px;position: absolute;top: 700px" @click="dialogFormVisible = true">
      <div class="acuu"><el-button id="acu-button"></el-button></div>
      <span style="font-size: 14px;position: absolute;top: 160px">大生纺12号冷风机</span>
      <div class="buttonC" style="text-align: left">
        <el-button class="a"><span id="all">改前耗电:<span style="color: blue">{{ ktThreeA }}</span>kWh</span></el-button>
        <el-button class="b"><span id="all">改后耗电:<span style="color: blue">{{ ktThreeB }}</span>kWh</span></el-button>
        <el-button class="c"><span id="all">累计节省电能:<span style="color: blue">{{ ktThreeC }}</span>kWh</span></el-button>
        <el-button class="d"><span id="all">实时节电率:<span style="color: red">{{ ktThreeD }}</span>%</span></el-button>
        <el-button class="e"><span id="all">近一天最高节电率:<span style="color: red">{{ ktThreeE }}</span>%</span></el-button>
        <el-button class="f"><span id="all">近一天平均节电率:<span style="color: red">{{ ktThreeF }}</span>%</span></el-button>
      </div>
    </div>-->
  </div>
</template>

<script>
export default {
  name: "None",
  data(){
    return{

    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/None.vue